// extracted by mini-css-extract-plugin
module.exports = {"globalNotifications":"globalNotifications__x-yz6"};